module.exports = __webpack_public_path__ + "img/syukyaku-top-016.962712f5.jpg";